import React, { Component } from "react";
import styled from "styled-components";
import { observer } from "mobx-react";
import { CaseHistoryStore } from "Store";
import { Scrollbars } from "react-custom-scrollbars";
import Avatar from "module-common/Avatar";
import Header from "module-case-management/info-panel/Header";
import CustomerField from "module-case-management/info-panel/customer-field/CustomerFieldWithQueryMutation";
import CustomerNote from "module-case-management/info-panel/CustomerNoteWithQueryMutation";
import CaseNote from "module-case-management/info-panel/CaseNoteWithMutation";
import LabelListCase from "module-case-management/info-panel/LabelListCaseWithQueryMutation";
import LabelListCustomer from "module-case-management/info-panel/LabelListCustomerWithQueryMutation";

// this component is responsible for showing info panel
export default observer(
  class InfoPanel extends Component {
    render() {
      const { selectedCase, showInfoPanel } = CaseHistoryStore;

      // early out if not showing info panel
      if (!showInfoPanel) return null;

      // get case field
      const {
        id,
        labels,
        customerChannelHandler: { displayPicture, displayName }
      } = selectedCase;

      return (
        <Wrapper>
          <Header onClick={this.onClosePanel} />
          <Scrollbars>
            <ContentWrapper>
              <Customer>
                <TitleRow>
                  <Title>Customer Profile</Title>
                </TitleRow>
                <StyledLabelListCustomer case={{ id }} />
                <Info>
                  <CustomerInfo>
                    <Avatar image={displayPicture} />
                  </CustomerInfo>
                  <CustomerField customerName={displayName} case={{ id }} />
                </Info>
                <CustomerNote case={{ id }} />
              </Customer>
              <Case>
                <TitleRow>
                  <Title>Case Info</Title>
                </TitleRow>
                <StyledLabelListCase id={id} labels={labels.slice()} />
                <CaseNote case={{ id }} />
              </Case>
            </ContentWrapper>
          </Scrollbars>
        </Wrapper>
      );
    }

    onClosePanel = () => {
      CaseHistoryStore.showInfoPanel = false;
    };
  }
);

const Wrapper = styled.div`
  flex: none;
  width: 300px;
  display: flex;
  flex-direction: column;
  border-left: 1px solid ${props => props.theme.panelBorder};
`;
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const TitleRow = styled.div`
  display: flex;
  margin-bottom: 10px;
`;
const Title = styled.div`
  color: ${props => props.theme.uiText};
  font-size: 0.8rem;
  font-weight: bold;
  margin-right: auto;
`;
const Customer = styled.div`
  padding: 20px;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
`;
const Case = styled.div`padding: 20px;`;
const Info = styled.div`
  display: flex;
  margin-bottom: 10px;
`;
const CustomerInfo = styled.div`
  display: flex;
  flex-direction: column;
`;
const StyledLabelListCase = styled(LabelListCase)`margin-bottom: 16px;`;
const StyledLabelListCustomer = styled(LabelListCustomer)`margin-bottom: 16px;`;



// WEBPACK FOOTER //
// ./src/module-case-history/InfoPanelWithStore.js